import type { ButtonProps } from "@chakra-ui/react";
import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext";
import { VIEW_CLAIM_STATUS_EVENT_UA, VIEW_CLAIM_STATUS_EVENT } from "modules/common/trackingConsts";
import { NavButton } from "./NavButton";

export const ViewClaimStatusButton = (props: ButtonProps) => {
  const translations = useTranslations();

  return (
    <NavButton
      href={`${config.webappUrl}/claims-and-flights`}
      title={translations("view_claim_status")}
      gaEvent={VIEW_CLAIM_STATUS_EVENT}
      uaEvent={VIEW_CLAIM_STATUS_EVENT_UA}
      dataTestId="top-navbar-view-status-button"
      {...props}
    />
  );
};
